import { RUN_STATUSES, type RunStatus } from "@the-drop/types";

const RUN_STATUS_LABEL: Record<RunStatus, string> = {
  proposed: "Proposed",
  driver_assigned: "Assigned",
  driver_confirmed: "Confirmed",
  en_route_to_dispensary: "En route",
  at_dispensary: "At dispensary",
  out_for_delivery: "Out for delivery",
  completed: "Completed",
  voided: "Voided",
};

function badgeCls(status: RunStatus): string {
  switch (status) {
    case "completed":
      return "bg-green-pale text-green ring-1 ring-green/20";
    case "voided":
      return "bg-gray-200 text-dark ring-1 ring-gray-300/80";
    case "out_for_delivery":
    case "en_route_to_dispensary":
    case "at_dispensary":
      return "bg-amber-bg text-amber-900 ring-1 ring-amber/30";
    case "driver_assigned":
    case "driver_confirmed":
    case "proposed":
    default:
      return "bg-blue-light text-blue ring-1 ring-blue/25";
  }
}

function normalizeRunStatus(raw: string): RunStatus | null {
  return RUN_STATUSES.includes(raw as RunStatus) ? (raw as RunStatus) : null;
}

/** Human-readable label for filters and copy (not the raw API string). */
export function runStatusDisplayLabel(status: string): string {
  const s = normalizeRunStatus(status);
  return s != null ? RUN_STATUS_LABEL[s] : status;
}

/** Pill aligned with dashboard reference (assigned / in motion / complete / void). */
export function RunStatusBadge({ status }: { status: string }) {
  const s = normalizeRunStatus(status);
  const label = s != null ? RUN_STATUS_LABEL[s] : status;
  const cls = s != null ? badgeCls(s) : "bg-surface-alt text-gray ring-1 ring-border";
  return (
    <span
      className={`inline-flex max-w-full items-center rounded-full px-2.5 py-1 text-xs font-semibold uppercase tracking-wide ${cls}`}
    >
      {label}
    </span>
  );
}
